"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setParamCookies = exports.queueParamCookies = exports.$pendingParams = exports.getParamCookies = exports.paramCookies = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const nanostores_1 = require("nanostores");
var ParamName;
(function (ParamName) {
    ParamName["REFERRER_NAME"] = "celloN";
    ParamName["REFERRAL_CODE"] = "ucc";
    ParamName["UTM_SOURCE"] = "utm_source";
    ParamName["UTM_MEDIUM"] = "utm_medium";
    ParamName["UTM_CAMPAIGN"] = "utm_campaign";
    ParamName["UTM_TERM"] = "utm_term";
    ParamName["UTM_CONTENT"] = "utm_content";
    ParamName["FINANCE_ADS_ID"] = "s_id";
    ParamName["META_CLICK_ID"] = "fbclid";
    ParamName["META_BROWSER_ID"] = "_fbp";
    ParamName["TIKTOK_PIXEL_ID"] = "_ttcid";
    ParamName["GOOGLE_CLICK_IDENTIFIER"] = "gclid";
    ParamName["LINKEDIN_CLICK_ID"] = "li_fat_id";
})(ParamName || (ParamName = {}));
const paramCookiesMap = {
    referrerName: 'pleo_rn',
    referralCode: 'pleo_rc',
    latestReferrerName: 'pleo_latest_rn',
    latestReferralCode: 'pleo_latest_rc',
    utmSource: 'pleo_utm_source',
    utmMedium: 'pleo_utm_medium',
    utmCampaign: 'pleo_utm_campaign',
    utmTerm: 'pleo_utm_term',
    utmContent: 'pleo_utm_content',
    latestUtmSource: 'pleo_latest_utm_source',
    latestUtmMedium: 'pleo_latest_utm_medium',
    latestUtmCampaign: 'pleo_latest_utm_campaign',
    latestUtmTerm: 'pleo_latest_utm_term',
    latestUtmContent: 'pleo_latest_utm_content',
    hubspotToken: 'hubspotutk',
    financeAdsCookieName: 'pleo-finance-ads-id',
    linkedinClickId: 'li_fat_id',
    metaClickId: '_fbc',
    metaBrowserId: '_fbp',
    tikTokPixelId: '_ttp',
    googleClickIdentifier: 'gclid',
};
exports.paramCookies = [
    {
        paramName: ParamName.REFERRER_NAME,
        cookieName: paramCookiesMap.referrerName,
        cookieNameLatest: paramCookiesMap.latestReferrerName,
    },
    {
        paramName: ParamName.REFERRAL_CODE,
        cookieName: paramCookiesMap.referralCode,
        cookieNameLatest: paramCookiesMap.latestReferralCode,
    },
    {
        paramName: ParamName.UTM_SOURCE,
        cookieName: paramCookiesMap.utmSource,
        cookieNameLatest: paramCookiesMap.latestUtmSource,
    },
    {
        paramName: ParamName.UTM_MEDIUM,
        cookieName: paramCookiesMap.utmMedium,
        cookieNameLatest: paramCookiesMap.latestUtmMedium,
    },
    {
        paramName: ParamName.UTM_CAMPAIGN,
        cookieName: paramCookiesMap.utmCampaign,
        cookieNameLatest: paramCookiesMap.latestUtmCampaign,
    },
    {
        paramName: ParamName.UTM_TERM,
        cookieName: paramCookiesMap.utmTerm,
        cookieNameLatest: paramCookiesMap.latestUtmTerm,
    },
    {
        paramName: ParamName.UTM_CONTENT,
        cookieName: paramCookiesMap.utmContent,
        cookieNameLatest: paramCookiesMap.latestUtmContent,
    },
    {
        paramName: ParamName.FINANCE_ADS_ID,
        cookieName: paramCookiesMap.financeAdsCookieName,
    },
    {
        paramName: ParamName.META_CLICK_ID,
        cookieName: paramCookiesMap.metaClickId,
    },
    {
        paramName: ParamName.META_BROWSER_ID,
        cookieName: paramCookiesMap.metaBrowserId,
    },
    {
        paramName: ParamName.TIKTOK_PIXEL_ID,
        cookieName: paramCookiesMap.tikTokPixelId,
    },
    {
        paramName: ParamName.GOOGLE_CLICK_IDENTIFIER,
        cookieName: paramCookiesMap.googleClickIdentifier,
    },
    {
        paramName: ParamName.LINKEDIN_CLICK_ID,
        cookieName: paramCookiesMap.linkedinClickId,
    },
];
const getParamCookies = () => {
    return exports.paramCookies.reduce((all, { cookieName, cookieNameLatest }) => {
        const cookieValue = js_cookie_1.default.get(cookieName);
        const result = [
            ...all,
            {
                [cookieName]: cookieValue || '',
            },
        ];
        if (cookieNameLatest) {
            const cookieValueLatest = js_cookie_1.default.get(cookieNameLatest);
            result.push({
                [cookieNameLatest]: cookieValueLatest || '',
            });
        }
        return result;
    }, []);
};
exports.getParamCookies = getParamCookies;
exports.$pendingParams = (0, nanostores_1.atom)(null);
let consentListenerRegistered = false;
/**
 * Queues URL params for later cookie writing if advertising consent has not
 * yet been granted, and flushes immediately once it is. Without this, params
 * from the landing page would be lost if the user only consents after their
 * first navigation.
 *
 * Takes the consent check/subscription as parameters (rather than importing
 * them from `@commercial-website/consent`) to avoid a circular workspace
 * dependency — `packages/consent` already depends on this package.
 */
const queueParamCookies = (searchParams, consent) => {
    exports.$pendingParams.set(new URLSearchParams(searchParams));
    const flushPendingParamCookies = () => {
        const pendingParams = exports.$pendingParams.get();
        if (!pendingParams || !consent.hasAdvertisingConsent()) {
            return;
        }
        (0, exports.setParamCookies)(pendingParams);
        exports.$pendingParams.set(null);
    };
    if (!consentListenerRegistered) {
        consentListenerRegistered = true;
        consent.onConsentChange(flushPendingParamCookies);
    }
    flushPendingParamCookies();
};
exports.queueParamCookies = queueParamCookies;
const setParamCookies = (searchParams) => {
    exports.paramCookies.forEach(({ paramName, cookieName, cookieNameLatest }) => {
        const paramValue = searchParams.get(paramName);
        const existingCookieValue = js_cookie_1.default.get(cookieName);
        // If no param, do nothing
        if (!paramValue) {
            return;
        }
        // If cookieNameLatest is specified (e.g. pleo_latest_utm_source),
        // set the param value under this cookie name. This cookie will
        // always be overridden by subsequent page visits with the same
        // param and so will always have the latest value
        if (cookieNameLatest) {
            js_cookie_1.default.set(cookieNameLatest, paramValue, {
                expires: 365,
                ...(window.location.hostname !== 'localhost' && { domain: '.pleo.io' }),
            });
        }
        // If there's no existing cookie, store the param in a cookie. This
        // cookie will never get overridden and will always be the first
        // value from the first visit with this param
        if (!existingCookieValue) {
            js_cookie_1.default.set(cookieName, paramValue, {
                expires: 365,
                ...(window.location.hostname !== 'localhost' && { domain: '.pleo.io' }),
            });
        }
    });
};
exports.setParamCookies = setParamCookies;
